import { useNavigate } from 'react-router-dom';
import Routes from '../../constants/routes';
import translation from '../../languages';
import { MaterialType } from '../../types/material-page';
import qualityEvents from '../../services/quality-events/quality-events';
import cn from '../../utils/classnames';
import MaterialLabel from '../material-label/material-label';
import { ReactComponent as MedalIcon } from './img/medal-icon.svg';
import QualityTooltip from './quality-tooltip';
import './quality-badge.scss';

type QualityBadgeProps = TranslationProps & {
    material: MaterialType;
    classNames?: string;
    noIcon?: boolean;
    noTooltip?: boolean;
};

const QualityBadge = ({ material, classNames, noIcon, noTooltip, t }: QualityBadgeProps) => {
    const navigate = useNavigate();
    const triggerText = t('qualityBadge.triggerText');

    const label = (
        <MaterialLabel variant='dark-green' classNames={cn('quality-badge-v2', classNames)}>
            {!noIcon && <MedalIcon aria-hidden='true' className='quality-badge-v2-icon' />}
            <span className='quality-badge-v2-text'>{triggerText}</span>
        </MaterialLabel>
    );

    const onLinkClick = () => {
        qualityEvents.materialPage.badges.qualityBadge(material);
        navigate(Routes.QUALITY_LANDING.path);
    };

    if (noTooltip) {
        return label;
    }

    return (
        <QualityTooltip id={`badge-${triggerText}`} onLinkClick={onLinkClick}>
            <div className='quality-badge'>{label}</div>
        </QualityTooltip>
    );
};

const translate = translation('quality');

export default translate(QualityBadge);
